module.exports = __webpack_public_path__ + "img/pro-img3.c36b272d.png";